import React, {useState, useEffect, createContext, useContext} from "react"
import { cognitoAuthenticate, getEmployeeAlias, getToken } from "src/auth/cognito-auth";
import { hasAftxCookie, authenticateWithAftx } from "src/auth/aftx-auth";
import { isAftxDomain } from "src/utils/aftx-utils";
import { isFcMenuDomain } from "src/utils/fc-utils";

export const defaultUserInfo = {
	loading: true,
	userAlias: "Guest",
	authToken: "",
	authType: "none" as "cognito" | "aftx" | "none"
}

export const AuthContext = createContext(defaultUserInfo);

export const useAuthContext = () => useContext(AuthContext)

export const AuthenticationContext = (props: any) => {
	
	const [userInfo, setUserInfo] = useState(defaultUserInfo);

	useEffect(() => {
		const authenticateUser = async () => {
			
			// Check if this is an AFTX domain
			if (isAftxDomain()||isFcMenuDomain()) {
				// For AFTX domains, check if AFTX cookie is present
				if (hasAftxCookie()) {
					const authResult = await authenticateWithAftx();
					if (authResult.authenticated && authResult.token) {
						setUserInfo({
							loading: false,
							userAlias: authResult.userAlias || 'AFTX User',
							authToken: document.cookie,
							authType: "aftx"
						});
					}
				}
			} else {
				// Not an AFTX domain, use regular Cognito authentication
				cognitoAuthenticate();
				setUserInfo({
					loading: false,
					userAlias: getEmployeeAlias(),
					authToken: getToken(),
					authType: "cognito"
				});
			}
		};

		authenticateUser();
	}, [])

	return (
		<AuthContext.Provider value={userInfo}>
			{props.children}
		</AuthContext.Provider>
	)
}
